import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, take, map, firstValueFrom } from 'rxjs';

export const fuelSaleGuard: CanActivateFn = async () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);
  return await firstValueFrom(
    toObservable(userStore.isLoaded).pipe(
      filter(loaded => loaded),
      take(1),
      map(() => {
        const canPass = userStore.isRetailFuels() && userStore.isShiptoSelectedWithPbl();

        return canPass ? true : router.createUrlTree(['/portal/home']);
      }),
    ),
  );
};
